import { render, staticRenderFns } from "./userGroup.vue?vue&type=template&id=8875fa6c&scoped=true"
import script from "./userGroup.vue?vue&type=script&lang=ts"
export * from "./userGroup.vue?vue&type=script&lang=ts"
import style0 from "./userGroup.vue?vue&type=style&index=0&id=8875fa6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8875fa6c",
  null
  
)

export default component.exports